<script>
import { mapGetters } from 'vuex'

export default {
  props: ['requiredReports', 'value'],
  created () {
    if (this.shouldBeLoaded) this.retry()
  },
  computed: {
    ...mapGetters('dashboard', ['isReportEmpty', 'isReportError', 'isReportLoading']),
    reportsHolder () {
      return this.$store.getters['dashboard/data']
    },
    shouldBeLoaded () {
      return this.requiredReports.every((reportName) => {
        return this.isReportEmpty(reportName) || this.isReportError(reportName)
      })
    },
    loading () {
      // Если хотя бы один из зависимых отчётов ещё загружается,
      // считаем, что загрузка ещё не окончена
      const condition1 = this.requiredReports.some(reportName => this.isReportLoading(reportName))

      // В то же время считаем, что если хотя бы один из отчётов не запрашивался или упал с ошибкой,
      // то загрузку останавливаем
      const condition2 = !this.requiredReports.some((reportName) => {
        return this.isReportEmpty(reportName) || this.isReportError(reportName)
      })

      return condition1 && condition2
      // console.log(condition1 && condition2)
      // return true
    },
    reports () {
      return this.loading
        ? null
        : this.requiredReports.reduce((acc, reportName) => {
          const reportValue = this.reportsHolder[reportName]
          acc[reportName] = reportValue
          return acc
        }, {})
    },
    errors () {
      // Если отчёт не на этапе загрузки, то определяем были ли в нём ошибки
      // Если ошибок не было, то возвращается null
      return this.loading
        ? null
        : this.requiredReports.reduce((acc, reportName) => {
          if (this.reportsHolder[reportName] === 'error') {
            if (acc == null) {
              acc = {}
            }
            acc[reportName] = 'error'
          }
          return acc
        }, null)
    }
  },
  methods: {
    retry () {
      this.$store.dispatch('dashboard/loadReports', this.requiredReports)
    }
  },
  render () {
    this.$emit('input', this.reports)
    return this.$scopedSlots.default({
      loading: this.loading,
      error: this.errors,
      retry: this.retry
    })
  }
}
</script>
